import React, { useState, useEffect, Fragment } from 'react';
import propTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import $ from 'jquery'

const defaultInternalStatusForRole = (roleId) => {
  const role = parseInt(roleId, 10);
  if (role === 53) return 'l2_pending';
  if (role === 61) return 'ct_pending';
  return '';
};

const headers = [
  'Business Id',
  'Site No',
  'Site Name',
  //'FD Ticket Id',
  'Complain Id',
  'Complain Type',
  //'Material Req.',
  //'Raised By',
  'Created On',
  'Internal Status',
  //'Status',
  'Actions',
];

const ViewComplainListSupport = ({ fetchComplainListL2Support, complainList,rmTicketFilter,getRmTicketsFilterDropDown }) => {
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const defaultInternalStatusId = defaultInternalStatusForRole(localStorage.getItem('fusion-role'));


  useEffect(() => {
    const tableData = [
      'lead_id',
      'site_no',
      'site_name',
      //'fd_ticket_id',
      'id',
      'complain_type',
      //'material_required',
      //'complain_raised_by',
      'created_at',
      'internal_status'
      //'status',
    ];

    if (complainList && complainList.resultSets.length > 0) {
      const data = complainList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ( 
            (key === 'internal_status' && element[key] === 'l2_pending') ? {[key]:'L2 Pending'}
            : { [key]: element[key] })),
          {
            Actions: {
              name: 'View Complain',
              link: `/dashboard/view-complain-l2/${element.id}`,
              item: element,
            },
          }
        )
      );
      if (data && data.length >0) {
      console.log(data);
        setListData(data);
        setPageCount(Math.ceil(complainList.total / complainList.per_page));
        setCurrentPage(complainList.current_page);
      }
    }else{
      setListData([]);
    }

  }, [complainList]);
  useEffect(() => {
    $('.modal-backdrop').remove();
    const installationCont = JSON.parse(
      localStorage.getItem("complaintCont") &&
        localStorage.getItem("complaintCont")
    );
    if(installationCont){
      localStorage.setItem("complaintList", JSON.stringify(""));
      localStorage.setItem("complaintCont", 0);
    }
    
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const getcontractFilter = await JSON.parse(
        localStorage.getItem("complaintList") &&
          localStorage.getItem("complaintList")
      );
      if(getcontractFilter){
        await fetchComplainListL2Support(getcontractFilter);
      }else{
        await fetchComplainListL2Support();
      }
      
      await getRmTicketsFilterDropDown();
      setIsLoading(false);
    })();
  }, [fetchComplainListL2Support]);

  

  const applyFilter = async (filterData) => {
    // console.log(filterData);
    localStorage.setItem("complaintList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchComplainListL2Support(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await fetchComplainListL2Support(filter,val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };
  const filterToggle = () => {
    setShowFilter(!showFilter);
  };


  return (
    <Layout title={localization.complainList} isLoading={isLoading} Buttons={headerBtns}>
      <TableSection
        data={listData}
        // isId={false}
        headers={headers}
        detailList={complainList}
        pageCount={pageCount}
        srNo={complainList?.from}
        currentPage={currentPage}
        onPageChange={onPageChange}
      />
      
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId=''
        listFilterData={rmTicketFilter?.sites ? rmTicketFilter : null}
        rmTicketFilter
        complaintFilter={true}
        defaultInternalStatusId={defaultInternalStatusId}
        hideL2ClientFilters={true}
        localstorageKey="complaintList"
      />
    </Layout> 
  );
};

ViewComplainListSupport.propTypes = {
  fetchComplainListL2Support: propTypes.func,
};

export default ViewComplainListSupport;
